/**
 * Named staleTime tiers for React Query.
 *
 * Pick the tier by how the data changes, not by page:
 * - LIVE:   job status, active task lists, recent dosing events (~30s)
 * - DATA:   sensor/chart/dashboard data — collectors run once daily (5m)
 * - CONFIG: tank config, target ranges, categories — user-edited, rarely (1h)
 * - STATIC: reference/lookup data that effectively never changes (24h)
 *
 * PERSIST_MAX_AGE bounds how old a localStorage-persisted cache entry may be
 * before hydration discards it. The global gcTime must be >= this value or
 * inactive queries get garbage-collected before they can be persisted.
 */
export const CACHE_TIMES = {
  LIVE: 30 * 1000,
  DATA: 5 * 60 * 1000,
  CONFIG: 60 * 60 * 1000,
  STATIC: 24 * 60 * 60 * 1000,
  PERSIST_MAX_AGE: 24 * 60 * 60 * 1000,
} as const;
